import { Typography } from '../../ui';
import { useTranslation } from '../../../../lib/i18n';
import { MAX_MESSAGE_ATTACHMENTS } from '../../../../lib/attachment-cap';

/**
 * The line a draft shows when a pick, paste or drop went past the server's attachment cap (or the attach
 * button was pressed on a full draft): only the first files that fit were added. The phones show the same
 * key as a toast.
 */
export function AttachmentLimitNotice() {
  const { t } = useTranslation();
  return (
    <Typography variant="p3" color="secondary" role="status" data-testid="attachment-limit-notice" style={{ padding: '0 4px 4px' }}>
      {t('chat.attachments.limit', { max: MAX_MESSAGE_ATTACHMENTS })}
    </Typography>
  );
}
